<template>
  <b-select
    id="selectOption"
    v-model="selectList"
    multiple
    :native-size="nativeSize"
    @input="selectSingle()"
    return-object
  >
    <option v-for="item in items" :key="item.code" :value="item">
      {{ item.name }}
    </option>
  </b-select>
</template>

<script>
export default {
  name: "SingleSelectList",

  components: {},

  props: {
    value: {
      type: Object,
      default: null,
    },
    items: {
      type: Array,
      default: function () {
        return [];
      },
    },
    nativeSize: {
      type: Number,
      default: 4,
    },
  },

  data() {
    const selectList = [];
    if (this.value) {
      selectList.push(this.value);
    }
    const selectListOld = JSON.parse(JSON.stringify(selectList));
    return {
      selectList: selectList,
      selectListOld: selectListOld,
    };
  },

  methods: {
    selectSingle: function () {
      const selectListNew = [];
      for (const selectItem of this.selectList) {
        if (!this.selectListOld.includes(selectItem)) {
          selectListNew.push(selectItem);
        }
      }
      if (selectListNew.length) {
        this.selectList = selectListNew;
        this.selectListOld = JSON.parse(JSON.stringify(selectListNew));
      } else {
        this.selectList = JSON.parse(JSON.stringify(this.selectListOld));
      }

      this.$emit("input", this.selectList.length ? this.selectList[0] : null);

      return;
    },
  },

  watch: {},

  filters: {},
};
</script>



// WEBPACK FOOTER //
// src/components/common/SingleSelectList.vue